import React, { useState } from 'react';
import Header from './components/Header'
import { Footer } from './components/Footer'
import { Contactform } from './components/Contactform'
import Bgimage from './images/about-nteplus-banner.webp'
import Icon01 from './images/Home01.webp'
import Icon02 from './images/Home02.webp'
import Icon03 from './images/ip04.webp'
import Icon04 from './images/Home09.webp'
import Icon05 from './images/Home07.webp'
import Icon06 from './images/Smart04.webp'
import Icon07 from './images/Smart01.webp'
import { Numbers } from './components/Numbers'
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

export const LatestUpdates = () => {
    const [state, setState] = useState({ turnover: 1, workforce: 1, states: 1, cities: 1 });  
  return (
    <>
    <Header />
    <section id='banner' className='p-0'>
            <div className='banner' style={{backgroundImage:'url('+Bgimage+')'}}>
                <div className='container'>
                    <div className='row'>
                        <div className='web-container'>
                          <div className='bannercont'  data-aos="zoom-in" data-aos-offset="200" data-aos-duration="600" data-aos-once="true" data-aos-easing="ease-in-sine">
                              <h2>📢 NOTICE TO CUSTOMERS 📢</h2>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id='homeautomation'>
                <div className='aboutnetplus'>
                        <div className='container'>
                                <div className='row'>
                                    <div className='web-container'>
  <div
    className='title'
    data-aos="fade-up"
    data-aos-offset="50"
    data-aos-duration="600"
    data-aos-once="true"
    data-aos-easing="ease-in-sine"
  >
    <span>
      Subject: FREE Broadband Speed Upgrade for Eligible Customers Activated Before 1/1/24
    </span>
  </div>

  <div
    className='smartcont'
    data-aos="fade-up"
    data-aos-offset="200"
    data-aos-duration="600"
    data-aos-once="true"
    data-aos-easing="ease-in-sine"
  >
    <p><strong>Dear Valued Customer,</strong></p>

    <p>We are excited to announce a <strong>FREE broadband speed upgrade</strong> for our loyal customers!</p>

    <p>
      If your broadband connection was activated <strong>before January 1, 2024</strong>,
      you are eligible to get your current internet speed <strong>doubled at no extra cost</strong>.
    </p>

    <p>To avail this offer, simply:</p>
    <ul>
      <li>Visit your nearest customer service center, or</li>
      <li>Call our Customer Care at <strong>70875-70875</strong></li>
    </ul>

    <p><strong>Upgrade Today and Enjoy Seamless High-Speed Internet!</strong></p>

    <p>Thank you for being a part of our network. We look forward to providing you with even better service.</p>

    <hr style={{ margin: "20px 0" }} />

    <p><strong>Disclaimer:</strong><br />
      This free broadband speed upgrade offer is valid only for eligible customers whose connections were activated before <strong>January 1, 2024</strong>, and who have <strong>not previously received a speed doubling</strong> under the “Double Dhamaka” plan. <br />
      Customers who have already availed this free speed upgrade are <strong>not eligible</strong> to receive it again. <br />
      <em>Terms and conditions apply.</em>
    </p>

    <p><strong>Call Center Number:</strong> 70875-70875</p>

    <p>
      <strong>Head Office Address:</strong><br />
      Jujhar Corporate Office<br />
      Level 5, Grand Walk<br />
      Ferozepur Road<br />
      Ludhiana 141012, Punjab
    </p>
  </div>
</div>

                                </div>
                        </div>
                </div>
      </section>
      
    <Footer />
    </>
  )
}
